import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import usePortalQuery from 'src/Libs/api/hooks/use-portal-query'
import { fetchInstallationStatus } from '../api/installation-status.api'
import { InstallationStatusModel } from '../types'
import { useCanViewInstallationDeviceStatus } from './use-can-view-installation-device-status'

export const installationStatusQueryKey = (installationIds?: number[]) => ['installation-status', installationIds] as const

interface UseInstallationStatusResult {
  data: InstallationStatusModel[]
  isLoading: boolean
}

/**
 * Custom hook to fetch installation status data for given installation IDs.
 * The query is enabled only if the user can view installation device status.
 */
export const useInstallationStatus = (installationIds?: number[]): UseInstallationStatusResult => {
  const authFetch = useAuthFetchWithResponse()

  const { canViewInstallationDeviceStatus } = useCanViewInstallationDeviceStatus()

  const { data, isLoading } = usePortalQuery({
    queryKey: installationStatusQueryKey(installationIds),
    queryFn: () => fetchInstallationStatus(authFetch, installationIds ?? PLACEHOLDER_ID),
    enabled: canViewInstallationDeviceStatus && !!installationIds && installationIds.length > 0,
  })

  return { data: data ?? [], isLoading }
}

/**
 * Placeholder ID since api expects an array. Enabled ensures that query is not executed when installationIds is undefined or empty.
 * Actual value does not matter since it is not used in that case.
 */
const PLACEHOLDER_ID = [0]
